import { OwnershipRulesFormValues, OwnershipEntities, OwnershipRequestPayload } from "./types";

/**
 * @deprecated Use OwnershipRequestPayload from types.ts instead
 */
export type OwnershipPayload = OwnershipRequestPayload;

/**
 * Builds a single ownership request payload from form values.
 * All rules are sent in one API call, with entity_type in each rule.
 */
export const buildOwnershipRequest = (
  ownerships: OwnershipRulesFormValues["ownerships"]
): OwnershipRequestPayload => {
  const firstEntityType = ownerships[0]?.entity_type ?? OwnershipEntities.WAREHOUSE;

  return {
    entity_type: firstEntityType,
    ownership_rules: ownerships.map(ownership => ({
      entity_type: ownership.entity_type,
      condition_key: ownership.condition_key,
      condition_type: ownership.condition_type,
      condition_value: ownership.condition_value,
      condition_key_value: ownership.condition_key_value,
    })),
  };
};

/**
 * @deprecated Use buildOwnershipRequest instead for single API call
 * Kept for backward compatibility with cost preview APIs
 */
export const buildOwnershipRequests = (
  ownerships: OwnershipRulesFormValues["ownerships"]
): OwnershipRequestPayload[] => {
  return [buildOwnershipRequest(ownerships)];
};
